import { FilterOption, GenericValueLabel } from '../../types';

export const handleFilterChanged = (
  filters: FilterOption[],
  filter: FilterOption | undefined,
  value: number | string,
  callback: (value: FilterOption[]) => void
): void => {
  if (!filter || filters.length === 0) return;
  const selectedValue = filter.items?.find((item: GenericValueLabel) => item.value === value);
  if (
    (!filter.isSearchText && !selectedValue) ||
    filter.selectedItems.find(
      (selectedItem: GenericValueLabel) => selectedItem.value === value
    )
  ) {
    return;
  }

  const newFilters = JSON.parse(JSON.stringify(filters));
  if (!filter.allowMultiSelect) {
    newFilters.find(
      (newFilter: FilterOption) => newFilter.header === filter.header
    ).selectedItems = [];
  }
  newFilters
    .find((newFilter: FilterOption) => newFilter.header === filter.header)
    .selectedItems?.push(filter.isSearchText ? value : selectedValue);

  callback(newFilters);
};

export const handleFilterRemoval = (
  filters: FilterOption[],
  filter: FilterOption,
  value: number | string,
  callback: (value: FilterOption[]) => void
): void => {
  if (!filter || filters.length === 0 || !value) return;
  const newFilters = JSON.parse(JSON.stringify(filters));
  if (!filter.allowMultiSelect) {
    newFilters.find(
      (newFilter: FilterOption) => newFilter.header === filter.header
    ).selectedItems = [];
  } else {
    newFilters.find(
      (newFilter: FilterOption) => newFilter.header === filter.header
    ).selectedItems = filter.selectedItems.filter(
      (item: GenericValueLabel) => item.value !== value
    );
  }
  callback(newFilters);
};
